import type { StringMap } from 'corgi-types';

import type { Variation } from './types';

export const getSelectedValues = (variations: Variation[]) => {
  const selection: StringMap<string> = {};

  variations.forEach(item =>
    item.groups.forEach(group =>
      group.values.forEach(value => value.selected && (selection[item.key] = value.title))
    )
  );

  return selection;
};
